import React from 'react';
import styled from 'styled-components';
import Grid from '@mui/material/Grid'
import BaseBox from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Box = styled(BaseBox)`
  margin-top: 0.5rem;

  ${props => props.theme.breakpoints.up('md')} {
    margin-top: 1.5rem;
  }

  ${props => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`;

const StatsNumber = styled(Typography)`
  font-size: 3.25rem;
  padding-right: 0.5rem;

  ${props => props.theme.breakpoints.up('md')} {
    font-size: 3.75rem;
  }
`;

const Text = styled(Typography)`
  line-height: 1.25rem;
`;

function TastyStats() {
  return (
    <Box display='flex' justifyContent='space-between'>
      <Box alignItems='center' display='flex'>
        <StatsNumber variant='h2'>7</StatsNumber>
        <Text>Days of Live <br /> Programming</Text>
      </Box>
      <Box alignItems='center' display='flex'>
        <StatsNumber variant='h2'>100+</StatsNumber>
        <Text>Original <br /> Shows</Text>
      </Box>
      <Box alignItems='center' display='flex'>
        <StatsNumber variant='h2'>27M</StatsNumber>
        <Text>YouTube <br /> Views</Text>
      </Box>
    </Box>
  );
}

export default React.memo(TastyStats);
